import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from 'src/shared/services/client/client.service';

@Injectable({
  providedIn: 'root',
})
export class ClinicAuthDataService {
  private clientService = inject(ClientService);

  verifyAndLink(): Observable<any> {
    return this.clientService.requestWithClient((client) =>
      client.trialmanagementexternal.VerifyAndLinkClinicProfile()
    );
  }

  getMyClinicProfile(): Observable<any> {
    return this.clientService.requestWithClient((client) => client.trialmanagementexternal.GetMyClinicProfile());
  }

  updateMyClinicProfileAvatar(avatarVariant: string): Observable<void> {
    return this.clientService.requestWithClient((client) =>
      client.trialmanagementexternal.UpdateMyClinicProfileAvatar({ avatar_variant: avatarVariant })
    );
  }
}
